import { Box, Typography } from '@mui/material';
import Chart from 'react-google-charts';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { AmountWithCurrency } from 'src/shared/components/atoms/amountWithCurrency';
import { useTranslation } from 'react-i18next';
import { FundraiserPaymentDistributionResponse } from '../models/fundraiserPaymentDistributionResponse';

type FundraiserSummaryChartPieProps = {
  paymentDistribution?: FundraiserPaymentDistributionResponse;
  totalAmount: number;
};

export const FundraiserSummaryChartPie = (props: FundraiserSummaryChartPieProps) => {
  const { paymentDistribution, totalAmount } = props;
  const { t } = useTranslation();

  const bankgiroAmount = paymentDistribution?.bankgiroAmount || 0;
  const swishAmount = paymentDistribution?.swishAmount || 0;
  const cardAmount = paymentDistribution?.cardAmount || 0;
  const cashAmount = paymentDistribution?.cashAmount || 0;

  // Kontrollera om alla värden är noll
  const isAllZero = bankgiroAmount === 0 && swishAmount === 0 && cardAmount === 0 && cashAmount === 0;

  const defaultColor = ['#dcdcdc'];

  const data = [
    ['Task', 'Funds per category'],
    [t('fundraiser:paymentMethods.bankgiro'), paymentDistribution?.bankgiroAmount || 0],
    [t('fundraiser:paymentMethods.swish'), paymentDistribution?.swishAmount || 0],
    [t('fundraiser:paymentMethods.card'), paymentDistribution?.cardAmount || 0],
    [t('fundraiser:paymentMethods.cash'), paymentDistribution?.cashAmount || 0],
  ];

  const chartData = !isAllZero
    ? data
    : [
        ['Task', 'Funds per category'],
        [t('fundraiser:noDonations'), 1],
      ];

  const theme = useTheme();

  const isXS = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ position: 'relative', ml: { xs: 0, md: -2 } }}>
      <Box display='flex' justifyContent='center'>
        <Chart
          width='100%'
          height='250px' // Set legend height to 100% to fill the container
          chartType='PieChart'
          data={chartData}
          options={{
            pieHole: 0.8,
            is3D: false,
            chartArea: { left: 0, top: 0, width: isXS ? '100%' : '80%', height: '100%' },
            colors: isAllZero ? defaultColor : ['#FFBB28', '#0088FE', '#00C49F', '#FF8042'],
            pieSliceText: 'none',
            legend: 'none',
            title: 'none',

            slices: {},
          }}
        />
      </Box>
      <Box
        sx={{
          position: 'absolute',
          top: { xs: '50%', sm: '50%' },
          left: { xs: '50%', sm: '40%' },

          transform: 'translate(-50%, -50%)',
          fontWeight: 'bold',
          fontSize: '18px',
        }}
      >
        <Typography sx={{ display: 'inline' }} variant='h4' fontWeight={(thm) => thm.typography.fontWeightBold}>
          <AmountWithCurrency
            compact
            compactDecimals={totalAmount >= 1000000 ? 2 : 1}
            amount={totalAmount}
            decimals={2}
            showCurrencyInSecondaryStyle
          />
        </Typography>
      </Box>
    </Box>
  );
};
